import { Outlet } from 'react-router-dom';

import { Page } from '@components';
import { routes } from '@routes';

export function ActivityLayout() {
  return (
    <Page
      title="Activity"
      tabs={[
        {
          label: 'Activity',
          to: routes.Activity.path,
        },
        {
          label: 'Reports',
          to: routes.Reports.path,
        },
      ]}
    >
      <Outlet />
    </Page>
  );
}
